import { PdfTemplate } from "components"
import type { ItemBuildReportRow } from "../types/itemBuildReport"
import {
  buildItemBuildExportPdfRows,
  ITEM_BUILD_EXPORT_COLUMNS,
} from "../utils/itemBuildExportData"

type ExportPdfItemBuildReportProps = {
  data: ItemBuildReportRow[]
  periodLabel: string
  module?: string
  title?: string
}

export function ExportPdfItemBuildReport({
  data,
  periodLabel,
  module = "INVENTORY",
  title = "ITEM BUILD REPORT",
}: ExportPdfItemBuildReportProps) {
  return (
    <PdfTemplate
      data={buildItemBuildExportPdfRows(data)}
      module={module}
      title={title}
      column={[...ITEM_BUILD_EXPORT_COLUMNS]}
      date={periodLabel}
      dateLabel="Period:"
      marginTable={55}
    />
  )
}
